module.exports = __webpack_public_path__ + "static/media/galerija_2022_0020.44bc3aac.jpg";